import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';

import { Home } from '../home';
import { SaleService } from './service/sale.service';
import { Classify } from './model/classify.model';

declare var $: any;

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss']
})

export class SalesComponent extends Home implements OnInit {

  @ViewChild('f') form;

  classifys: any;
  get: Subscription;
  put: Subscription;
  post: Subscription;

  isLoading: boolean = false;
  
  constructor(private saleService: SaleService, private router: Router, public classify: Classify) {
    super(router);
  }

  ngOnInit() {
    this.list();
  }

  list() {
    this.isLoading = true;
    this.get = this.saleService.get()
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.classifys = ret.items;
        }
        this.isLoading = false;
      },
        err => {
          console.log(err);
          this.isLoading = false;
          this.allowAcess(err.status);
        });
  }

  doClassify(classify: Classify, valid: boolean) {

    if (!valid)
      return;

    if (!classify.id) {
      this.doCreated(classify);
    } else {
      this.doUpdated(classify);
    }
  }

  doUpdated(clas) {

    this.put = this.saleService.put(clas.id, clas)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.list();
          $('#myModal').modal('hide');
          this.openMessenge('Registro atualizado com sucesso.', 'success');
          this.clean();
        } else {
          this.openMessenge(ret.messege, 'danger');
        }
      },
        err => {
          console.log(err);
          this.openMessenge('Não foi possivel concluir a operação.', 'danger');
          this.allowAcess(err.status);
        });
  }

  doCreated(clas) {

    this.post = this.saleService.post(clas)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.list();
          $('#myModal').modal('hide');
          this.openMessenge('Registro cadastrado com sucesso.', 'success');
          this.clean();
        } else {
          this.openMessenge(ret.messege, 'danger');
        }
      },
        err => {
          console.log(err);
          this.openMessenge('Não foi possivel concluir a operação.', 'danger');
          this.allowAcess(err.status);
        });
  }

  loadRegister(id) {
    this.classify = this.classifys.find(f => f.id == id);
    $('#myModal').modal('show');
  }

  clean() {
    this.classify = new Classify();
    this.form.resetForm();
  }

  ngOnDestroy() {
    if (this.get)
      this.get.unsubscribe();

    if (this.put)
      this.put.unsubscribe();

    if (this.post)
      this.post.unsubscribe();
  }
}
